// FILE: client/src/constants/creditConstants.js
export const CREDIT_LIST_REQUEST = "CREDIT_LIST_REQUEST";
export const CREDIT_LIST_SUCCESS = "CREDIT_LIST_SUCCESS";
export const CREDIT_LIST_FAIL = "CREDIT_LIST_FAIL";

export const CREDIT_ADMIN_LIST_REQUEST = "CREDIT_ADMIN_LIST_REQUEST";
export const CREDIT_ADMIN_LIST_SUCCESS = "CREDIT_ADMIN_LIST_SUCCESS";
export const CREDIT_ADMIN_LIST_FAIL = "CREDIT_ADMIN_LIST_FAIL";

export const CREDIT_DETAILS_REQUEST = "CREDIT_DETAILS_REQUEST";
export const CREDIT_DETAILS_SUCCESS = "CREDIT_DETAILS_SUCCESS";
export const CREDIT_DETAILS_FAIL = "CREDIT_DETAILS_FAIL";

export const CREDIT_CREATE_REQUEST = "CREDIT_CREATE_REQUEST";
export const CREDIT_CREATE_SUCCESS = "CREDIT_CREATE_SUCCESS";
export const CREDIT_CREATE_FAIL = "CREDIT_CREATE_FAIL";
export const CREDIT_CREATE_RESET = "CREDIT_CREATE_RESET";

export const CREDIT_UPDATE_REQUEST = "CREDIT_UPDATE_REQUEST";
export const CREDIT_UPDATE_SUCCESS = "CREDIT_UPDATE_SUCCESS";
export const CREDIT_UPDATE_FAIL = "CREDIT_UPDATE_FAIL";
export const CREDIT_UPDATE_RESET = "CREDIT_UPDATE_RESET";

export const CREDIT_DELETE_REQUEST = "CREDIT_DELETE_REQUEST";
export const CREDIT_DELETE_SUCCESS = "CREDIT_DELETE_SUCCESS";
export const CREDIT_DELETE_FAIL = "CREDIT_DELETE_FAIL";
export const CREDIT_DELETE_RESET = "CREDIT_DELETE_RESET";
